"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _parseToRgb = _interopRequireDefault(require("polished/lib/color/parseToRgb"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SNOW_WHITE = (0, _parseToRgb.default)('#FFFFFF');
var FULL_MOON = (0, _parseToRgb.default)('#F1F2F8');
var HALF_MOON = (0, _parseToRgb.default)('#E3E8F1');
var QUARTER_MOON = (0, _parseToRgb.default)('#C5CAD3');
var ALASKAN_HUSKY = (0, _parseToRgb.default)('#737482');
var BLACK_SHEEP = (0, _parseToRgb.default)('#3E3F4D');
var MIDNIGHT = (0, _parseToRgb.default)('#2F3039');
var CHARCOAL = (0, _parseToRgb.default)('#25262E');
var baseColors = {
  snowWhite: _objectSpread({}, SNOW_WHITE, {
    fg: CHARCOAL
  }),
  fullMoon: _objectSpread({}, FULL_MOON, {
    fg: CHARCOAL
  }),
  halfMoon: _objectSpread({}, HALF_MOON, {
    fg: CHARCOAL
  }),
  quarterMoon: _objectSpread({}, QUARTER_MOON, {
    fg: CHARCOAL
  }),
  alaskanHusky: _objectSpread({}, ALASKAN_HUSKY, {
    fg: SNOW_WHITE
  }),
  blackSheep: _objectSpread({}, BLACK_SHEEP, {
    fg: SNOW_WHITE
  }),
  midnight: _objectSpread({}, MIDNIGHT, {
    fg: SNOW_WHITE
  }),
  charcoal: _objectSpread({}, CHARCOAL, {
    fg: SNOW_WHITE
  })
};
var _default = baseColors;
exports.default = _default;